<div class="connect-cta-container">
  <mat-card class="connect-cta-card">
    <mat-card-title>Connect your Notion workspace first</mat-card-title>
    <mat-card-content>
      <p>{{ message }}</p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" routerLink="/start">Connect Notion</button>
    </mat-card-actions>
  </mat-card>
</div>
